import UrlParse from 'url-parse'
import Env from './env'
import Fly from 'flyio/dist/npm/fly'
import _ from 'underscore'
import axios from "axios"
import qs from "qs"


var host = Env.serverIp;

function setAuth(value)
{
    var c_name = 'bunande_auth';
    var expiredays = 365;
    var exdate=new Date()
    exdate.setDate(exdate.getDate()+expiredays)
    document.cookie=c_name+ "=" +escape(value)+
        ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
}




function setRole(value)
{
    var c_name = 'bunande_auth_role';
    var expiredays = 365;
    var exdate=new Date()
    exdate.setDate(exdate.getDate()+expiredays)
    document.cookie=c_name+ "=" +escape(value)+
        ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
}
// function setAuth(page)



function getRole()
{
    var c_name =  'bunande_auth_role';
    if (document.cookie.length>0)
    {
        let c_start=document.cookie.indexOf(c_name + "=")
        if (c_start!=-1)
        {
            c_start=c_start + c_name.length+1
            let c_end=document.cookie.indexOf(";",c_start)
            if (c_end==-1) c_end=document.cookie.length
            return unescape(document.cookie.substring(c_start,c_end))
        }
    }
    return ""
}


function isSuperAdmin(){
    return (getRole() == 1)?true:false
}


function isFive(){
    return (getRole() == 60)?true:false
}

function setAuthWithRefresh(value)
{
    var c_name = 'django_auth_refresh';
    var expiredays = 365;
    var exdate=new Date()
    exdate.setDate(exdate.getDate()+expiredays)
    document.cookie=c_name+ "=" +escape(value)+
        ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
}


function customStoreSet(key,value)
{
    var c_name = key;
    var expiredays = 365;
    var exdate=new Date()
    exdate.setDate(exdate.getDate()+expiredays)
    document.cookie=c_name+ "=" +escape(value)+
        ((expiredays==null) ? "" : ";expires="+exdate.toGMTString())
}


function customStoreGet(key)
{
    var c_name = key;
    if (document.cookie.length>0)
    {
        let c_start=document.cookie.indexOf(c_name + "=")
        if (c_start!=-1)
        {
            c_start=c_start + c_name.length+1
            let c_end=document.cookie.indexOf(";",c_start)
            if (c_end==-1) c_end=document.cookie.length
            return unescape(document.cookie.substring(c_start,c_end))
        }
    }
    return ""
}

//取回cookie或localStorage中的token
function getAuth()
{
    // 优先从 localStorage 获取 saas_token (直客端)
    var saasToken = localStorage.getItem('saas_token');
    if (saasToken) {
        return saasToken;
    }

    var c_name =  'bunande_auth';
    if (document.cookie.length>0)
    {
        let c_start=document.cookie.indexOf(c_name + "=")
        if (c_start!=-1)
        {
            c_start=c_start + c_name.length+1
            let c_end=document.cookie.indexOf(";",c_start)
            if (c_end==-1) c_end=document.cookie.length
            return unescape(document.cookie.substring(c_start,c_end))
        }
    }
    return ""
}
// function getAuth(page)
// {
//     return page.$store.state.accessToken;
// }


//取回cookie
function getRefreshToken()
{
    var c_name =  'django_auth_refresh';
    if (document.cookie.length>0)
    {
        let c_start=document.cookie.indexOf(c_name + "=")
        if (c_start!=-1)
        {
            c_start=c_start + c_name.length+1
            let c_end=document.cookie.indexOf(";",c_start)
            if (c_end==-1) c_end=document.cookie.length
            return unescape(document.cookie.substring(c_start,c_end))
        }
    }
    return ""
}

function queryValue(name)
{
    let urlParse = UrlParse(location.href,true);
    console.log(urlParse)
    let query = urlParse.query;
    return query[name]?query[name]:'';
}


function authRequest(config)
{

    if( config.indicator )
    {
        config.page.$indicator.open('处理中');
    }

    //添加请求头

    if( getAuth(config) )
    {
        config.page.$http.interceptors.request.use((request)=>{
            request.headers["Authorization"]="Bearer " + getAuth(config.page)
        })
    }


    let requestData = config.data;
    if( config.type == 'get')
    {
        config.page.$http.get(config.url,requestData).then((res)=>{

            if( config.indicator )
            {
                config.page.$indicator.close();
            }

            config.success(res.data);
        }).catch(err=>{
            if( config.indicator )
            {
                config.page.$indicator.close();
            }
        });
    } else {
        config.page.$http.post(config.url,requestData).then((res)=>{

            if( config.indicator )
            {
                config.page.$indicator.close();
            }

            config.success(res.data);
        }).catch(err=>{
            if( config.indicator )
            {
                config.page.$indicator.close();
            }

        });
    }
}


function checkToken(page)
{
    // if( !getAuth(page) )
    // {
    //     page.$router.push('/auth');
    //     return;
    // }
}

function cusHttp(page,url,param,method)
{
    if( !param ){
        param = {}
    }

    page.$http.interceptors.request.use((request)=>{
        if( getAuth(page) )
        {
            request.headers["Authorization"]="Bearer " + getAuth(page)
        }
    })

    //响应拦截器
    //添加响应拦截器，响应拦截器会在then/catch处理之前执行
    page.$http.interceptors.response.use(
        (response) => {
        },
        (err) => {
            if ( err.status == 401 )
            {
                //清除token

                //新开一个fly请求
                return new Fly().post(dynamicHost() + '/edu/token/refresh' , {refresh:getRefreshToken()}).then((res)=>{
                    if( !res.data.access )
                    {
                        //如果当前是auth则不处理了
                        let urlParse = UrlParse(location.href,true);
                        if ( urlParse.pathname == '/auth' )
                        {
                            return;
                        }else
                        {
                            location.href = '/auth'
                            return;
                        }
                    }
                    setAuth(res.data.access)
                    return page.$http.request(err.request)
                }).catch((res)=>{
                    //跳转到登录页面
                    //如果当前是auth页面则不处理
                    let urlParse = UrlParse(location.href,true);
                    if ( urlParse.pathname == '/auth' )
                    {
                        return;
                    }else
                    {
                        location.href = '/auth'
                        return;
                    }
                });
            }
        }
    )

    if( method == 'get')
    {
        return page.$http.get( dynamicHost() + url,param );
    }else
    {
        return page.$http.post( dynamicHost() + url,param );
    }
}


function commonHttp(url, data) {
    if( !data ){
        data = {}
    }

    // let raw_data = JSON.stringify(data)
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    return axios.post( dynamicHost() +  url, qs.stringify(data))
}


function mAlert(page,message)
{
    page.$toast({
        message: message,
        position: 'middle',
        duration: 3000
    });
}


function dynamicHost()
{
    return host;
}

function setTitle(title)
{
    document.title = title;
}

function statusText(stage) {
    let statusArr = {
        "101": "确认分期信息",
        "201": "填写个人资料",
        "301": "身份信息认证",
        "401": "确认基本资料",
        "402": "绑定银行卡",
        "501": "签署电子协议",
        "601": "审核中",
        "701": "申请完成"
    }

    if ( statusArr[stage] )
    {
        return statusArr[stage];
    }

    return '';
}


/**获得教育机构的名称和电话等信息**/
function eduInfo()
{
    return new Fly().get(dynamicHost() + '/bor/get_edu_name')
}

function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;
}

function getUrlParam(paraName){
    var url = document.location.toString();
    var arrObj = url.split("?");

    if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");

            if (arr != null && arr[0] == paraName) {
                return arr[1];
            }
        }
        return "";
    }
    else {
        return "";
    }
}

function polishingImg(src)
{

    //TODO
    if(src)
    {
        if( src.indexOf('http') !== -1 )
        {
            return src;
        }else{
            return Env.serverIp + src
        }
        return Env.serverIp + src
    } else
    {
        return '#'
    }
}

function paddingZero(classifyId)
{
    if( classifyId < 10 )
    {
        return '0' + classifyId
    }else
    {
        return classifyId
    }
}


function classifyConfig()
{
    return [
        {id:1, name:'化工原料', type2id:209, like_groups: '', like_fits: '', selected: false},
        {id:2, name:'颜料油漆', type2id:210, like_groups: '', like_fits: '', selected: false},
        {id:3, name:'日化用品', type2id:211, like_groups: '', like_fits: '', selected: false},
        {id:4, name:'燃料油脂', type2id:212, like_groups: '', like_fits: '', selected: false},
        {id:5, name:'医药用品', type2id:213, like_groups: '', like_fits: '', selected: false},
        {id:6, name:'金属材料', type2id:214, like_groups: '', like_fits: '', selected: false},
        {id:7, name:'机械设备', type2id:215, like_groups: '', like_fits: '', selected: false},
        {id:8, name:'手工器械', type2id:216, like_groups: '', like_fits: '', selected: false},
        {id:9, name:'科学仪器', type2id:217, like_groups: '', like_fits: '', selected: false},
        {id:10, name:'医疗器械', type2id:218, like_groups: '', like_fits: '', selected: false},
        {id:11, name:'灯具空调', type2id:219, like_groups: '', like_fits: '', selected: false},
        {id:12, name:'运输工具', type2id:220, like_groups: '', like_fits: '', selected: false},
        {id:13, name:'烟火相关', type2id:221, like_groups: '', like_fits: '', selected: false},
        {id:14, name:'珠宝钟表', type2id:222, like_groups: '', like_fits: '', selected: false},
        {id:15, name:'乐器', type2id:223, like_groups: '', like_fits: '', selected: false},
        {id:16, name:'办公用品', type2id:224, like_groups: '', like_fits: '', selected: false},
        {id:17, name:'橡胶制品', type2id:225, like_groups: '', like_fits: '', selected: false},
        {id:18, name:'皮革皮具', type2id:226, like_groups: '', like_fits: '', selected: false},
        {id:19, name:'建筑材料', type2id:227, like_groups: '', like_fits: '', selected: false},
        {id:20, name:'家具用品', type2id:228, like_groups: '', like_fits: '', selected: false},
        {id:21, name:'厨房洁具', type2id:229, like_groups: '', like_fits: '', selected: false},
        {id:22, name:'绳网袋蓬', type2id:230, like_groups: '', like_fits: '', selected: false},
        {id:23, name:'纱线丝', type2id:231, like_groups: '', like_fits: '', selected: false},
        {id:24, name:'布料床单', type2id:232, like_groups: '', like_fits: '', selected: false},
        {id:25, name:'服装鞋帽', type2id:233, like_groups: '', like_fits: '', selected: false},
        {id:26, name:'纽扣拉链', type2id:234, like_groups: '', like_fits: '', selected: false},
        {id:27, name:'地毯席垫', type2id:235, like_groups: '', like_fits: '', selected: false},
        {id:28, name:'健身器材', type2id:236, like_groups: '', like_fits: '', selected: false},
        {id:29, name:'食品', type2id:237, like_groups: '', like_fits: '', selected: false},
        {id:30, name:'方便食品', type2id:238, like_groups: '', like_fits: '', selected: false},
        {id:31, name:'饲料种籽', type2id:239, like_groups: '', like_fits: '', selected: false},
        {id:32, name:'啤酒饮料', type2id:240, like_groups: '', like_fits: '', selected: false},
        {id:33, name:'酒精饮品', type2id:241, like_groups: '', like_fits: '', selected: false},
        {id:34, name:'香烟烟具', type2id:242, like_groups: '', like_fits: '', selected: false},
        {id:35, name:'广告销售', type2id:243, like_groups: '', like_fits: '', selected: false},
        {id:36, name:'金融物管', type2id:244, like_groups: '', like_fits: '', selected: false},
        {id:37, name:'建筑修理', type2id:245, like_groups: '', like_fits: '', selected: false},
        {id:38, name:'通讯服务', type2id:246, like_groups: '', like_fits: '', selected: false},
        {id:39, name:'运输贮藏', type2id:247, like_groups: '', like_fits: '', selected: false},
        {id:40, name:'材料加工', type2id:248, like_groups: '', like_fits: '', selected: false},
        {id:41, name:'教育娱乐', type2id:249, like_groups: '', like_fits: '', selected: false},
        {id:42, name:'网站服务', type2id:250, like_groups: '', like_fits: '', selected: false},
        {id:43, name:'餐饮住宿', type2id:251, like_groups: '', like_fits: '', selected: false},
        {id:44, name:'医疗园艺', type2id:252, like_groups: '', like_fits: '', selected: false},
        {id:45, name:'社会服务', type2id:253, like_groups: '', like_fits: '', selected: false}
    ]
}

function classifyText(classifyId)
{
    if( classifyId ) {
        // return _.where(this.classifyConfig(), {id: classifyId})[0].name
        if( _.where(this.classifyConfig(), {id: parseInt(classifyId)}).length )
        {
           return _.where(this.classifyConfig(), {id: parseInt(classifyId)})[0].name
        }
    }

    return ''
}

function classifyImg(classifyId)
{
    return dynamicHost() + '/boot/public/images/classify/' + classifyId + '.png'
}


function classifyImg2(classifyId)
{
    return dynamicHost() + '/boot/public/images/icon/' + paddingZero(classifyId) + '.png'
}

function strCount(str_val){
    let res = 0
    let res_arr = str_val.split(',')
    return res_arr.length
}

function visitStatic(href){
    console.log("执行访问统计功能")
    return new Fly().get(dynamicHost() + '/boot/mobile_new.php?action=static', {url: href} )
}



export default {
    setAuth:setAuth,
    setAuthWithRefresh:setAuthWithRefresh,
    getAuth:getAuth,
    authRequest:authRequest,
    host:host,
    dynamicHost:dynamicHost,
    customStoreSet:customStoreSet,
    customStoreGet:customStoreGet,
    mAlert:mAlert,
    queryValue:queryValue,
    cusHttp:cusHttp,
    statusText:statusText,
    setTitle:setTitle,
    eduInfo:eduInfo,
    checkToken:checkToken,
    getQueryString:getQueryString,
    getUrlParam: getUrlParam,
    polishingImg: polishingImg,
    classifyConfig: classifyConfig,
    paddingZero: paddingZero,
    classifyText: classifyText,
    classifyImg: classifyImg,
    commonHttp: commonHttp,
    setRole: setRole,
    isFive: isFive,
    classifyImg2: classifyImg2,
    isSuperAdmin: isSuperAdmin,
    strCount: strCount,
    visitStatic: visitStatic
}
